<template>
  <v-menu
    v-model="menuOpen"
    class="sw-time-picker-field-menu"
    :close-on-content-click="false"
    transition="scale-transition"
    :offset="offset"
    location="bottom start"
    content-class="sw-time-picker-menu"
  >
    <template #activator="{ props: menuProps }">
      <v-text-field
        v-bind="{ ...menuProps, ...$attrs }"
        :model-value="displayValue"
        :label="label"
        :density="density"
        :variant="variant"
        :hide-details="hideDetails"
        :style="fieldStyle"
        :disabled="disabled"
        :readonly="true"
        :clearable="clearable && !!modelValue"
        color="primary"
        prepend-inner-icon="mdi-clock-outline"
        :class="fieldClasses"
        :rules="rules"
        @click:clear="clearValue"
      />
    </template>

    <v-card class="sw-time-picker" elevation="0">
      <header class="sw-time-picker__header">
        <v-icon icon="mdi-clock-outline" size="18" />
        <span>{{ pickerTitle }}</span>
      </header>

      <v-time-picker
        v-model="draft"
        color="primary"
        :format="format"
        class="sw-time-picker__picker"
        full-width
      />

      <footer class="sw-time-picker__footer">
        <v-btn variant="text" class="text-none" @click="onCancel">
          Cancel
        </v-btn>
        <v-btn variant="flat" class="primary-btn text-none" @click="onApply">
          OK
        </v-btn>
      </footer>
    </v-card>
  </v-menu>
</template>

<script>
/**
 * Shared time field — mirrors SwDatePickerField.
 * Use with TicketActionField (label="") or standalone with :label.
 */
export default {
  name: "SwTimePickerField",

  inheritAttrs: false,

  props: {
    modelValue: { type: String, default: null },
    label: { type: String, default: "Select time" },
    pickerTitle: { type: String, default: "Select time" },
    format: { type: String, default: "ampm" },
    density: { type: String, default: "comfortable" },
    variant: { type: String, default: "outlined" },
    hideDetails: { type: [Boolean, String], default: true },
    fieldStyle: { type: [String, Object], default: undefined },
    offset: { type: [Number, String, Array], default: 8 },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
  },

  emits: ["update:modelValue", "apply", "cancel", "clear"],

  data() {
    return {
      menuOpen: false,
      draft: this.modelValue || null,
    };
  },

  watch: {
    modelValue(val) {
      if (!this.menuOpen) this.draft = val || null;
    },
    menuOpen(open) {
      if (open) this.draft = this.modelValue || null;
    },
  },

  computed: {
    fieldClasses() {
      const attrClass = this.$attrs.class;
      const usesTadControl =
        (typeof attrClass === "string" && attrClass.includes("tad-control")) ||
        (Array.isArray(attrClass) &&
          attrClass.some((c) => String(c).includes("tad-control")));

      return usesTadControl
        ? ["sw-time-field"]
        : ["sw-float-field", "sw-time-field"];
    },

    displayValue() {
      if (!this.modelValue) return "";
      return String(this.modelValue);
    },
  },

  methods: {
    onApply() {
      this.$emit("update:modelValue", this.draft || null);
      this.$emit("apply", this.draft || null);
      this.menuOpen = false;
    },
    onCancel() {
      this.draft = this.modelValue || null;
      this.$emit("cancel");
      this.menuOpen = false;
    },
    clearValue() {
      this.draft = null;
      this.$emit("update:modelValue", null);
      this.$emit("clear");
    },
  },
};
</script>
